require('./contractPayrollLoanStepOne.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKCalculationWaffer = require('components/commons/OKCalculationWaffer/OKCalculationWaffer');

//@components
const ContractLoanAccounts = require('../../contractLoanAccounts/contractLoanAccounts');
const ContractLoanDaySelector = require('../../contractLoanDaySelector/contractLoanDaySelector');
const ContractPayrollLoanBiggerImport = require('../../contractPayrollLoan/contractPayrollLoanBiggerImport/contractPayrollLoanBiggerImport');
const ContractLoanDueInformation = require('../../contractLoanDueInformation/contractLoanDueInformation');

// @constants
const { PERCENTAGE_SYMBOL } = require('constants/index');
const { BLOCKED_ACCOUNTS_CONTRACT_PAYROLL_LOAN } = require('constants/operationCodesAccounts');

//@utilities
const { formatAmount, decimalsLength, getFormattedString, formatCurrency } = require('utilities/currencyHelper');

class ContractPayrollLoanStepOne extends React.Component {
    constructor(props) {
        super(props);
        this.handlePaymentDayChange = this.handlePaymentDayChange.bind(this);
    }

    addPercentage(value) {
        return formatAmount(value, 2).concat(' ', PERCENTAGE_SYMBOL);
    }

    buildAccounts() {
        const {
            getBlockedAccounts,
            immAccounts,
            immContractPayrollLoan,
            immFlagBasedFeatures,
            setSelectedAccount,
        } = this.props;
        const selectedAccount = immContractPayrollLoan.get('selectedAccount');
        const errorSelectedAccount = immContractPayrollLoan.get('emptySelectedAccount');
        const disclaimer = {
            warning: 'contractPayrollLoanStepOne-contractPayrollLoanStepOne_blockedAccountsWarning',
            important: 'contractPayrollLoanStepOne-contractPayrollLoanStepOne_blockedAccountsImportant'
        };
        const errorMsgSelectedAccount = formatText('contractPayrollLoanStepOne-contractPayrollLoanStepOne_errorMsgSelectedAccount');

        return (
            <ContractLoanAccounts
                blockedAccountsContract={BLOCKED_ACCOUNTS_CONTRACT_PAYROLL_LOAN}
                disclaimer={disclaimer}
                getBlockedAccounts={getBlockedAccounts}
                immAccounts={immAccounts}
                immFlagBasedFeatures={immFlagBasedFeatures}
                setSelectedAccount={setSelectedAccount}
                selectedAccount={selectedAccount}
                errorSelectedAccount={errorSelectedAccount}
                errorMsgSelectedAccount={errorMsgSelectedAccount}
            />
        );
    }

    buildAppovedText() {
        const { immContractPayrollLoan } = this.props;
        const ammountRaw = immContractPayrollLoan.get('selectedAmount');
        const decimalsLengthLoanImport = decimalsLength(ammountRaw);
        const selectedTerm = immContractPayrollLoan.get('selectedTerm');
        const amount = getFormattedString({
            amount: ammountRaw,
            currency: immContractPayrollLoan.get('currency'),
            decimalsLength: decimalsLengthLoanImport
        });
        return formatText('contractPayrollLoanStepOne-approved', [amount, selectedTerm]);
    }

    buildBiggerImport() {
        const { immContractPayrollLoan, getInstallment,
            setLoanAmount, setLoanTerm, getMinTerm } = this.props;

        const showNewOfferView = immContractPayrollLoan.get('showNewOfferView');
        const showBiggerImport = immContractPayrollLoan.get('showBiggerImport');
        const offer = immContractPayrollLoan.get('offer');
        const show = (showBiggerImport) || showNewOfferView;
        const customValues = show && !offer.get('changed') ? offer : null;

        return show ? (
            <ContractPayrollLoanBiggerImport
                customValues={customValues}
                immContractPayrollLoan={immContractPayrollLoan}
                getInstallment={getInstallment}
                setLoanAmount={setLoanAmount}
                setLoanTerm={setLoanTerm}
                getMinTerm={getMinTerm}
                showBox
                showTitle
                showSubtitle
            />
        ) : null;
    }

    buildRadioButtonSection() {
        const { immContractPayrollLoan } = this.props;
        const paymentDaySelected = immContractPayrollLoan.get('paymentDaySelected');

        return (
            <ContractLoanDaySelector
                firstRadioButtonLabel="contractPayrollLoanStepOne-firstRadioButtonLabel"
                message="contractPayrollLoanStepOne-radioMessageText"
                onPaymentDayChange={this.handlePaymentDayChange}
                paymentDaySelected={paymentDaySelected}
                secondRadioButtonLabel="contractPayrollLoanStepOne-secondRadioButtonLabel"
            />
        );
    }

    buildInstallment() {
        const { immContractPayrollLoan } = this.props;
        const immCollective = immContractPayrollLoan.getIn(['collectiveInformation', '0']);
        const isCollective = immContractPayrollLoan.get('isCollective');
        return (isCollective && immCollective) ? {
            amount: immCollective.get('installment'),
            currency: immContractPayrollLoan.get('currency'),
            decimalsLength: decimalsLength(immCollective.get('installment'))
        } : immContractPayrollLoan.get('installment');
    }

    buildWaffer() {
        const { immContractPayrollLoan, taeTooltip } = this.props;

        const immCollective = immContractPayrollLoan.getIn(['collectiveInformation', '0']);
        const isCollective = immCollective && immContractPayrollLoan.get('isCollective');
        const rawTae = isCollective ? immCollective.get('tae') : immContractPayrollLoan.get('tae');
        const rawTin = isCollective ? immCollective.get('tin') : immContractPayrollLoan.get('tin');

        const rawArrangementFee = immContractPayrollLoan.get('arrangementFee');
        const rawCurrency = immContractPayrollLoan.get('currency');

        const currency = formatCurrency(rawCurrency);
        const installment = getFormattedString(this.buildInstallment());

        const tin = this.addPercentage(rawTin);
        const tae = this.addPercentage(rawTae);
        const decimalsArragementFee = decimalsLength(rawArrangementFee);
        const arrangementFee = formatAmount(rawArrangementFee, decimalsArragementFee);

        const values = [
            {
                title: formatText('contractPayrollLoanStepOne-anualTin'),
                bodyText: tin
            },
            {
                title: formatText('contractPayrollLoanStepOne-TAE'),
                bodyText: tae,
                icon: 'icon-informacion',
                tooltipPlacement: 'right',
                tooltipModifier: 'dark-bg',
                tooltipAlternativeIcon: true,
                tooltipClassName: 'contract-payroll-loan-step-one__tooltip',
                iconCustomClass: 'contract-payroll-loan-step-one__tae-icon',
                tooltipOffset: [10, 0],
                className: 'item-tae',
                information: taeTooltip
            },
            {
                title: formatText('contractPayrollLoanStepOne-arrangementFee',
                    [immContractPayrollLoan.get('arrangementPercentage')]),
                bodyText: `${arrangementFee} ${currency}`,
                additionalLabel: (<sup>1</sup>),
            }
        ];

        const content = immContractPayrollLoan.get('isFetchingInstallment') ?
            (
                <LoadingSection />
            )
            : (
                <OKCalculationWaffer
                    itemsList={values}
                    outstandedLabel={formatText('contractPayrollLoanStepOne-monthlyInstallment')}
                    outstandedText={installment}
                />
            );

        return (
            <div className="contract-payroll-loan-step-one__waffer">
                {content}
            </div>
        );
    }

    handlePaymentDayChange(paymentDay) {
        const { setPaymentDay, getInstallment } = this.props;

        setPaymentDay({ paymentDay });
        getInstallment();
    }

    render() {
        const accountsSelector = this.buildAccounts();
        const dateRadios = this.buildRadioButtonSection();
        const approvedText = this.buildAppovedText();
        const waffer = this.buildWaffer();
        const biggerImport = this.buildBiggerImport();

        return (
            <section className="contract-payroll-loan-step-one">
                <div className="contract-payroll-loan-step-one__title">
                    <FormattedText value="contractPayrollLoanStepOne-confirmationTitle" />
                </div>
                <p className="contract-payroll-loan-step-one__message">
                    <FormattedText value="contractPayrollLoanStepOne-message" />
                </p>
                <p className="contract-payroll-loan-step-one__approved">
                    {approvedText}
                </p>
                <div className="contract-payroll-loan-step-one__separator"></div>
                {biggerImport}
                {waffer}
                {accountsSelector}
                {dateRadios}
                <ContractLoanDueInformation title="gdprNominaLoan-title" message="gdprNominaLoan-contractMessage" />
            </section>
        );
    }
}

ContractPayrollLoanStepOne.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    getMinTerm: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractPayrollLoan: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    setPaymentDay: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    taeTooltip: PropTypes.object.isRequired
};

module.exports = ContractPayrollLoanStepOne;
